import React from "react";
import * as Flex from "../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import type { BaseModelGradeType } from "../../../../../../common-deprecated/types/CommonTypes";
import { useBnbSelector } from "../../../redux/store";
import Grade from "./Grade";
import { getVisualForGradeImage } from "../../../../../../common-deprecated/settings/utils/ccisSettingUtils";
import { getCarImageFromConfig } from "../../../../../shared-logic/utils/typedUtils";

type GradeListProps = {
    modelId: string;
    modelName: string;
    grades: (BaseModelGradeType & { defaultCarId?: string; carId?: string })[];
};

const GradeList = ({ modelId, grades, modelName }: GradeListProps): JSX.Element => {
    const settings = useBnbSelector((state) => state.commonSettings);
    const filterItems = useBnbSelector((state) => state.model.filterItems);
    const filterEquipment = useBnbSelector((state) => state.utils.filterEquipment);
    const isSelected = filterEquipment.split(":")[0] === "true";

    return (
        <Flex.Row>
            {grades.map((modelGrade, index) => (
                <Grade
                    // Add index because filtering can move an item with the
                    // same id to a different order
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${modelGrade.id}-${modelGrade.bodyType?.id}-${index}`}
                    modelId={modelId}
                    modelName={modelName}
                    grade={modelGrade as any}
                    getGradeImage={(width: number, height: number, gradeId: string, bodyTypeId: string) =>
                        filterItems.length
                            ? getCarImageFromConfig(
                                  settings,
                                  "day-exterior",
                                  4,
                                  modelId,
                                  modelGrade.defaultCarId!,
                                  { type: "jpg", width, height },
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  undefined,
                                  false,
                                  null,
                                  false,
                                  isSelected ? filterItems : [],
                              )
                            : getVisualForGradeImage(settings, modelId, gradeId, bodyTypeId, {
                                  width,
                                  height,
                                  padding: 0,
                                  scaleMode: 0,
                              }).src
                    }
                />
            ))}
        </Flex.Row>
    );
};

export default GradeList;
